import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  // getData,
  // changeDate,
  // changeType,
  // changeVsMorD,
  getSelect,
  // changeSelectStatusChart,
  // getChart,
  getNewChart,
} from "../actions/dashboardServicios";
import moment from "moment";
import {
  // Button,
  DatePicker,
  PageHeader,
  Radio,
  Spin,
  // message as messageAntd,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./dealerProfile.css";

import NewChart from "../components/NewChart";
// import ChartDS from "../components/chartDS";

function DashboardServicios(props) {
  const loading = useSelector((state) => state.dashboardServicios.loading);
  // const year = useSelector((state) => state.dashboardServicios.year);
  // const month = useSelector((state) => state.dashboardServicios.month);
  // const type = useSelector((state) => state.dashboardServicios.type);
  // const typeData = useSelector((state) => state.dashboardServicios.typeData);
  // const vsMorD = useSelector((state) => state.dashboardServicios.vsMorD);
  // const data = useSelector((state) => state.dashboardServicios.data);
  // const dataChart = useSelector((state) => state.dashboardServicios.dataChart);
  // const select = useSelector((state) => state.dashboardServicios.select);
  // const selectStatusChart = useSelector(
  //   (state) => state.dashboardServicios.selectStatusChart
  // );

  const [response, setResponse] = useState([]);

  const dispatch = useDispatch();
  // const currentDay = Number(moment().format("D"));
  // const currentMonth = Number(moment().format("M"));
  // const currentYear = Number(moment().format("YYYY"));

  useEffect(() => {
    dispatch(getSelect());
  }, [dispatch]);

  // function loadDataChart(type) {
  //   if (
  //     selectStatusChart[type].idBrand != null &&
  //     selectStatusChart[type].month != null &&
  //     selectStatusChart[type].year != null
  //   ) {
  //     dispatch(
  //       getChart(
  //         type,
  //         selectStatusChart[type].idIndicator,
  //         selectStatusChart[type].idBrand,
  //         selectStatusChart[type].year,
  //         selectStatusChart[type].month
  //       )
  //     );

  //     localStorage.setItem(
  //       "selectStatusChartV3",
  //       JSON.stringify(selectStatusChart)
  //     );
  //   } else {
  //     messageAntd.warning("Todos los campos son necesarios");
  //   }
  // }

  // function onChangeSelectStatusChart(type, select, value) {
  //   dispatch(changeSelectStatusChart(type, select, value));
  // }

  // function onChangeDate(date, dateString) {
  //   if (date != null) {
  //     dispatch(
  //       changeDate(Number(date.format("YYYY")), Number(date.format("M")))
  //     );
  //   } else {
  //     dispatch(changeDate(0, 0));
  //   }
  // }

  // function onChangeData() {
  //   if (year > 0 && month > 0) {
  //     dispatch(getData(year, month, type, vsMorD));
  //   } else {
  //     messageAntd.warning("Todos los campos son necesarios");
  //   }
  // }

  // function onChangeType(e) {
  //   dispatch(changeType(e.target.value));
  // }

  // function onChangeTypeData(e) {

  //   console.log('onchangetype > ', e.target.value );

  //   if (e.target.value === 1) {

  //     if (!select.new) {

  //       console.log('> ', select.new );

  //       dispatch(getSelect())
  //     }
  //   }
  //   dispatch(changeTypeData(e.target.value))
  // }

  // function onChangeVsMorD(e) {
  //   dispatch(changeVsMorD(e.target.value));
  // }

  const [isLoading, setIsLoading] = useState(false);
  const [identificador, setIdentificador] = useState("1");

  const fetchData = useCallback(
    async (year, month) => {
      setIsLoading(true);
      const currentYear = year ?? Number(moment().format("YYYY"));
      const currentMonth = month ? month + 1 : Number(moment().format("M"));

      const response = await dispatch(
        getNewChart("NAN", identificador, 0, currentYear, currentMonth)
      );

      if (!response?.error) {
        setResponse(response?.result);
        setIsLoading(false);
      }
    },
    [dispatch, identificador]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div style={{ margin: "18px" }}>
      <Spin
        spinning={loading || isLoading}
        tip="Cargando..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <PageHeader
          className="m-page-header"
          style={{ paddingBottom: "20px" }}
          onBack={null}
          title={
            <div style={{ fontSize: "18px" }}>
              Dashboard Servicios | Grupo Optima
            </div>
          }
          subTitle={null}
        />

        <div className="dp-table-container">
          {/* <ChartDS
            select={select}
            selectStatusChart={selectStatusChart}
            onChangeSelectStatusChart={onChangeSelectStatusChart}
            dataChart={dataChart}
            loadData={loadDataChart}
          /> */}

          <div className="container_new_table">
            <div className="dp-line">
              <h4>Ordenes público</h4>

              <span className="dp-chart-select" />

              <Radio.Group
                defaultValue={identificador}
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
              >
                <Radio.Button value="1">Cantidades ($)</Radio.Button>
                <Radio.Button value="2">Ordenes (#)</Radio.Button>
              </Radio.Group>

              <DatePicker
                bordered={false}
                format="YYYY-MM"
                onChange={(value) => fetchData(value.year(), value.month())}
                placeholder="Fecha"
                picker="month"
                allowClear={false}
              />
            </div>
            {response.length &&
              Object.entries(response[0])?.map((item, index) => (
                <NewChart
                  key={index}
                  data={item}
                  type="Ordenes público"
                  identificador={identificador}
                />
              ))}
          </div>
        </div>
      </Spin>
    </div>
  );
}

export default DashboardServicios;
